import parallaxBg from "@assets/_1 Oceanfront Oahu vacation rental exterior with direct beach access_1759338102610.jpg";
// The shared page-hero clip: Mokoli'i and the Ko'olau range from the air (graded drone footage).
const wavesVideo = "/videos/mokolii-aerial-hero.mp4";
const wavesPoster = "/videos/mokolii-aerial-hero-poster.jpg";
import beachShoreline from "@assets/Timber and Love Stay With Us - Chinaman_s Ocean Front Beach House Airbnb Beach_1758545423883.jpg";

/** The Kualoa house's own clip: the house from the water, used on its listing page. */
const kualoaHeroVideo = "/videos/oahu-beachfront-vacation-rental-kualoa-beach-house.mp4";
const kualoaHeroPoster = "/videos/oahu-beachfront-vacation-rental-kualoa-beach-house-poster.jpg";

/** Portfolio (Vacation Rental Oahu) media: the coast itself, no single home in frame. */
const portfolioHeroVideo = "/videos/vacation-rental-oahu-coast.mp4";
const portfolioHeroPoster = "/videos/vacation-rental-oahu-coast-poster.jpg";
const portfolioShoreline = "/images/oahu/kaaawa-shoreline.jpg";
const portfolioAerial = "/images/oahu/mokolii-aerial.jpg";
const portfolioHammock = "/images/oahu/hammock-mokolii.jpg";

export { parallaxBg, wavesVideo, wavesPoster, beachShoreline, kualoaHeroVideo, kualoaHeroPoster, portfolioHeroVideo, portfolioHeroPoster, portfolioShoreline, portfolioAerial, portfolioHammock };
